import React, { useState, useEffect } from 'react';
import '../../Pages/RealtimeInferencingPageV3/style/index.css';
import Dropdown from '../customize-dropdown';
import { FaGear } from 'react-icons/fa6';
import { RiArrowGoBackLine } from 'react-icons/ri';
import axios from 'axios';
import EditableTable from '../editable-table';
import { FcInfo } from 'react-icons/fc';
import PixelComponent from '../new-pixel-component';
import { IoArrowBackCircleOutline } from 'react-icons/io5';
import { APIClient } from '../../../helpers/apiHelper';
import Modal from '../modal';

function DevicesModal({
  inputDevices,
  setDeviceId,
  setInputDevices,
  globalState,
  setGlobalState,
  mediaTypeSwitcher,
  handleNext,
  startVideoStream,
  setShowDeviceModal,
  showDeviceModal,
  api,
  token,
}) {
  const [openDropdown, setOpenDropdown] = useState(false);
  const [lengthDeviceArray, setLengthDeviceArray] = useState(0);
  const [isChecked, setIsChecked] = useState(false);
  const [optionValue, setOptionValue] = useState('');
  const [isConfig, setIsConfig] = useState(false);
  const [isPixel, setIsPixel] = useState(false);
  const [itemDrop, setItemDrop] = useState();
  const apiClient = new APIClient();

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
    mediaTypeSwitcher();
  };

  useEffect(() => {
    if (isChecked) {
      setOptionValue('Share');
      setGlobalState((prevState) => ({
        ...prevState,
        optionValueDevice: 'Share',
      }));
    } else {
      setOptionValue('USB');
      setGlobalState((prevState) => ({
        ...prevState,
        optionValueDevice: 'USB',
      }));
    }
  }, [isChecked]);

  useEffect(() => {
    const interval = setInterval(() => {
      checkDeviceChanges();
    }, 5000); // Check every 5 seconds

    return () => clearInterval(interval); // Cleanup on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const fetchUltrasoundMachines = async () => {
    try {
      const machines = await apiClient.getUltrasoundMachines();
      setItemDrop(machines.data);
    } catch (error) {
      console.error('Failed to fetch ultrasound machines:', error);
    }
  };
  useEffect(() => {
    fetchUltrasoundMachines();
  }, [isConfig]);
  useEffect(() => {
    if (
      globalState.deviceId ||
      globalState.selectedItem !== 'Select your machine'
    ) {
      setGlobalState((prevState) => ({
        ...prevState,
        isVideoFrozen: true,
        // isStart: !prevState.isStart
      }));
    }
    else{
      setIsChecked(!isChecked);
      if(isChecked){
        setOptionValue('Share');
        setGlobalState((prevState) => ({
          ...prevState,
          optionValueDevice: 'Share',
        }));
      }else{
        setOptionValue('USB');
        setGlobalState((prevState) => ({
          ...prevState,
          optionValueDevice: 'USB',
        }));
      }
    }
  }, [showDeviceModal, globalState.deviceId, globalState.isStart]);
  const checkDeviceChanges = () => {
    if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
      navigator.mediaDevices
        .enumerateDevices()
        .then((devices) => {
          setLengthDeviceArray(devices?.length);
          setInputDevices(
            devices.filter((device) => {
              return (
                device.kind === 'videoinput' &&
                device.label.toLowerCase().indexOf('integrateaaad') === -1 &&
                device.label.toLowerCase().indexOf('cameraaa') === -1
              );
            })
          );
        })
        .catch((error) => {
          console.error('Error enumerating devices: ', error);
        });
    } else {
      console.error('enumerateDevices is not supported on this browser');
    }
  };

  useEffect(() => {
    if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
      navigator.mediaDevices
        .enumerateDevices()
        .then((devices) => {
          setLengthDeviceArray(devices?.length);
          setInputDevices(
            devices.filter((device) => {
              return (
                device.kind === 'videoinput' &&
                device.label.toLowerCase().indexOf('integrated') === -1 &&
                device.label.toLowerCase().indexOf('webcam') === -1
              );
            })
          );
        })
        .catch((error) => {
          console.error('Error enumerating devices: ', error);
        });
    } else {
      console.error('enumerateDevices is not supported on this browser');
    }
  }, []);
  useEffect(() => {
    if (!globalState?.deviceId) {
       setIsPixel(false);
    }
  }, [globalState?.deviceId]);
  useEffect(() => {
    console.log("showDeviceModal ::"  , showDeviceModal,globalState.deviceId,globalState.selectedItem );
    if (
      !showDeviceModal ||
      !globalState.deviceId ||
      globalState.selectedItem == 'Select your machine'
    ) {
      setIsConfig(false);
      setIsPixel(false);
    } else {
      if (
        !globalState?.pixelSpacingConfig?.pixel_spacing &&
        globalState.deviceId &&
        globalState.selectedItem !== 'Select your machine'
      ) {
        setIsPixel(true);
      }
    }
  }, [showDeviceModal]);
  const options: {
    label: string;
    value: 'newWebRTC' | 'oldWebRTC' | 'newWS';
  }[] = [
    { label: 'New WebRTC', value: 'newWebRTC' },
    { label: 'Old WebRTC', value: 'oldWebRTC' },
    { label: 'New WebSocket', value: 'newWS' },
  ];

  return (
    <div
      className={`${
        showDeviceModal ? 'visible' : 'hidden'
      } fixed inset-0 z-40 flex h-full items-center justify-center`}
    >
      <Modal
        isOpen={showDeviceModal}
        onClose={() => {
          setShowDeviceModal(!showDeviceModal);
        }}
        size={isConfig || isPixel ? 'extraLarge' : 'small'}
        className="bg-card-color-200"
      >
        <Modal.Header
          title={
            isPixel ? (
              <div className="flex items-center justify-center space-x-3">
                {(!globalState.deviceId ||
                  globalState.selectedItem == 'Select your machine') && (
                  <div
                    className="cursor-pointer"
                    onClick={() => {
                      setIsPixel(false);
                    }}
                  >
                    <IoArrowBackCircleOutline size={24} />
                  </div>
                )}
                <div>Get your pixel spacing</div>
              </div>
            ) : (
              <div className="inline-flex items-center justify-center space-x-3">
                <div>Configure your machine</div>
                <FaGear
                  size={18}
                  className="cursor-pointer text-title-page-color-200"
                  onClick={() => {
                    setIsConfig(!isConfig);
                  }}
                />
              </div>
            )
          }
          onClose={() => {
            setShowDeviceModal(!showDeviceModal);
          }}
          displayClose={true}
        />
        <Modal.Content>
          {isConfig ? (
            <div className="w-full p-3">
              <div>
                <EditableTable api={api} token={token} />
              </div>
            </div>
          ) : isPixel ? (
            <PixelComponent
              setGlobalState={setGlobalState}
              globalState={globalState}
              setShowDeviceModal={setShowDeviceModal}
            />
          ) : (
            <div className="relative h-full w-full">
              <div className="relative h-full w-full p-3">
                {!globalState?.pixelSpacingConfig?.pixel_spacing && (
                  <div className="w-full rounded-lg border border-[#8ed9f6] p-2 text-xs text-title-page-color-100">
                    <span className="inline-flex space-x-2 font-bold">
                      NOTICE :{' '}
                    </span>
                    it's better to obtain the pixel spacing value before
                    proceeding with the real-time exam.
                    <a
                      className="underline-offset-8 text-title-page-color-200 hover:text-[#2a6fa3] cursor-pointer"
                      onClick={() => setIsPixel(!isPixel)}
                    >
                      {' '}
                      Get Pixel Spacing
                    </a>
                  </div>
                )}

                <div className="w-full py-5">
                  <div className="text-lg font-semibold text-title-page-color-300">
                    Select Machine Type
                  </div>
                  <div className="mt-5">
                    <Dropdown
                      items={itemDrop}
                      isOpen={openDropdown}
                      setIsOpen={setOpenDropdown}
                      globalState={globalState}
                      setGlobalState={setGlobalState}
                    />
                  </div>
                </div>
                <div className="mb-4">
                  {globalState.machineType && (
                    <>
                      <div className="text-lg font-semibold text-title-page-color-300">
                        Select Input Device
                      </div>
                      <ul className="ml-1 mt-1 w-fit rounded-lg text-sm font-medium text-title-page-color-100">
                        {inputDevices.map((device, index) => (
                          <li key={index} className="w-full rounded-t-lg">
                            <div className="ps-3 flex items-center space-x-3">
                              <input
                                id={`device-checkbox-${index}`}
                                type="checkbox"
                                name="inputDevice"
                                value={device.label}
                                className="h-4 w-4 rounded border-gray-300 bg-gray-100 text-blue-600 outline-none"
                                onChange={() => {
                                  console.log("sasasasas :::")
                                  setDeviceId(device.deviceId);
                                  startVideoStream(); // Start video stream when device is selected
                                  handleNext();
                                }}
                              />
                              <label
                                htmlFor={`device-checkbox-${index}`}
                                className="ms-2 w-full py-3 text-sm font-medium text-title-page-color-100"
                              >
                                {device.label}
                              </label>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </>
                  )}
                </div>
                {/* <div className="mt-4 w-full mb-16">
                  <div className="text-lg font-semibold text-[#686C82]">Select Your Approach</div>
                  <div className="mt-5">
                    <SelectDropdownApproach
                      options={options}
                      value={globalState.approach}
                      onChange={value => setGlobalState(prev => ({ ...prev, approach: value }))}
                    />
                  </div>
                </div> */}
                <div className="absolute bottom-3 right-3 flex w-full items-center justify-end">
                  <div className="checkbox-wrapper-35 space-x-2">
                    <input
                      value="private"
                      name="switch"
                      id="switch"
                      type="checkbox"
                      className="switch"
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                    />
                    <label htmlFor="switch" className="mt-1"></label>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal.Content>
      </Modal>
    </div>
  );
}
export default DevicesModal;
